<template>
  <div class="home">
    <div style="width: 100%; height: 100%; overflow-y: hidden">
      <!-- aside菜单容器 -->
      <div ref="aside" class="aside" :style="asideStyle">
        <!-- 展开关闭菜单 -->
        <i
          v-if="isCollapse"
          class="open iconfont icon-open"
          @click="changeCollapse(false)"
        ></i>
        <i
          id="collapseOpen"
          v-else
          class="close iconfont icon-close"
          @click="changeCollapse(true)"
        ></i>
        <!-- 系统logo -->
        <div class="aside-logo" @click="goFirstPage">
          <img src="~assets/logo.png" class="aside-logo-img" alt="logo" />
          <span class="aside-logo-title" v-show="!isCollapse"
            >后台管理系统</span
          >
        </div>
        <el-scrollbar id="menuWarpper" style="height: calc(100% - 50px)">
          <!-- 搜索栏 -->
          <div class="menu-search">
            <el-input
              v-model="searchVal"
              v-show="!isCollapse"
              placeholder="输入菜单名称搜索"
              @input="filterList"
              clearable
            />
            <i
              v-show="isCollapse"
              class="el-icon-search menu-search-icon"
              @click="changeCollapse(false)"
            ></i>
          </div>
          <!-- 导航菜单 -->
          <el-menu
            class
            background-color="#3a3f51"
            text-color="#fff"
            active-text-color="#ffd04b"
            unique-opened
            default-active
            :collapse="isCollapse"
            router
          >
            <el-submenu
              v-for="(menu, index) in navList"
              :key="index"
              :index="index + 1 + ''"
            >
              <template slot="title">
                <i :class="menu.icon"></i>
                <span :id="'menu' + menu.title">{{ menu.title }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="(item, index2) in menu.childs"
                  :key="index + '-' + index2"
                  :index="item.path"
                  @click="handleMenu(item)"
                  :id="'menuTwo' + item.title"
                  style="text-indent: 15px"
                  >{{ item.title }}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-scrollbar>
      </div>
      <!-- main主题内容容器 -->
      <div ref="main" class="main" :style="mainStyle">
        <el-header class="home-header" height="50px">
          <div class="header-con">
            <!-- 标签页 -->
            <div class="header-con-tabs">
              <el-tabs
                class="tabs"
                style="margin-top: 10px"
                type="card"
                v-model="activeTab"
                @tab-remove="removeTab"
              >
                <el-tab-pane
                  v-for="(item, index) in tabList"
                  :key="index"
                  :label="item.title"
                  :name="item.name"
                  :closable="item.name != 'firstPage'"
                >
                  <template slot="label">
                    <router-link
                      @dblclick.native="removeTab(item.path)"
                      :to="item.path"
                      tag="span"
                      >{{ item.title }}
                    </router-link>
                  </template>
                </el-tab-pane>
              </el-tabs>
            </div>
            <!-- 用户头像 -->
            <el-dropdown id="profile" @command="handleCommand">
              <div class="userInfo">
                <span style="cursor: pointer">{{ userName }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
                <!-- <span v-if="userName">{{ userName }}</span> -->
                <!-- <img
                  v-if="!userName"
                  style="
                    height: 40px;
                    width: 40px;
                    border-radius: 50%;
                    margin-top: 5px;
                  "
                  src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                /> -->
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="chnagePass"
                  >修改密码</el-dropdown-item
                >
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <!-- 菜单页面容器 -->
        <div class="main-con" v-loading="$store.state.loading">
          <transition name="fade" mode="out-in">
            <keep-alive :include="keepAliveStr">
              <router-view></router-view>
            </keep-alive>
          </transition>
        </div>
      </div>
    </div>
    <!-- 密码修改 -->
    <el-dialog
      title="密码修改"
      :visible.sync="passDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="400px"
    >
      <el-form
        :model="passFormData"
        label-position="left"
        label-width="80px"
        :rules="passFormRule"
        ref="passForm"
      >
        <el-form-item label="旧密码" prop="old">
          <el-input
            v-model="passFormData.old"
            clearable
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new">
          <el-input
            v-model="passFormData.new"
            clearable
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; // 混入表单必填项

export default {
  name: "home",
  data() {
    return {
      /**导航菜单数据 */
      navList: [],
      /**按钮权限 */
      buttons :{},
      /**标签页数据 */
      tabList: [],
      /**活动状态的的tab */
      activeTab: "",
      isDay: true, //日间模式
      isCollapse: false,
      offsetLeft: "0px", //tabs的偏移量
      offsetIndex: 0,
      /**存储打开的标签页 */
      keepAlive: [],
      mainStyle: { width: "calc(100% - 200px)" },
      asideStyle: { width: "200px" },
      /**修改密码dialog */
      passDialog: false,
      passFormData: {
        old: "",
        new: "",
      },
      passFormRule: {
        old: [mustFill],
        new: [mustFill],
      },
      userName: "",

      /**菜单搜索框 */
      searchVal: "",
      navSource: [], //导航的源数据
    };
  },
  computed: {
    /**将keep-alive组件数组改为字符串 */
    keepAliveStr() {
      return this.keepAlive.join();
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.getNavList();
    this.$store.commit("getUserInfo");
    this.setLimit();
    if (localStorage.getItem("userId")) {
      this.userName = `${localStorage.getItem("name") || ""} ${
        localStorage.getItem("userName") || ""
      }`;
      this.userName = this.userName.trim();
    }
  },
  methods: {
    /**导航菜单搜索 */
    filterList() {
      this.$debounce(() => {
        if (this.searchVal === "") {
          this.navList = this.recursion(this.navSource);
        }

        let arr = [];

        this.navSource.forEach((item) => {
          if (item.Title.indexOf(this.searchVal) > -1) {
            arr.push(item);
          }
        });

        //需要将二级菜单的一级菜单添加上去
        //如果是Father为0，则不操作，如果非0，则查询当前数组中时候有这条数据，如果没有，则添加
        arr.forEach((item) => {
          if (item.FatherId != 0) {
            let isSave = arr.some((item2) => {
              return item2.Id == item.FatherId;
            });

            if (!isSave) {
              for (let i = 0; i < this.navSource.length; i++) {
                if (this.navSource[i].Id == item.FatherId) {
                  arr.push(this.navSource[i]);
                }
              }
            }
          }
        });
        this.navList = this.recursion(arr);
      });
    },

    init() {
      let routerStr = "firstPage";
      this.keepAlive = ["firstPage"];
      this.tabList = [{ title: "首页", path: "firstPage", name: "firstPage" }];
      if (this.$route.path.indexOf("home/") == -1) {
        this.$routerTo("home/" + routerStr);
      }
    },
    goFirstPage() {
      this.$routerTo("firstPage");
      this.handleMenu({ title: "首页", path: "firstPage" });
    },
    /**获取导航菜单数据 */
    getNavList() {
      let data = {
        userId: window.localStorage.getItem("userId"),
      };
      this.$request({
        url: "Role/GetUserMethod",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            if (res.list.length) {
              this.navList = this.recursion(res.list);
              this.navSource = res.list;
              // 获取按钮权限并存储到Vuex
              const buttons = this.getButtons(res.list); 
              this.buttons = buttons; // 存储到data  
              console.log('buttons', this.buttons); 
              this.$store.commit('setButtonPermissions', buttons);
            }
          }
          // 获取成功后价格导航菜单的数据存放在vuex中，方便调用
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**数据处理函数 */
    recursion(list) {
      let obj = {};
      for (let i = 0; i < list.length; i++) {
        if (!obj[list[i].FatherId || 0]) {
          obj[list[i].FatherId || 0] = [];
        }
        obj[list[i].FatherId || 0].push({
          id: list[i].Id,
          title: list[i].Title,
          path: list[i].Power,
          icon: list[i].IcoAddress,
          childs: [],
        });
      }
      for (let i = 0; i < obj[0].length; i++) {
        obj[0][i].childs = obj[obj[0][i].id];
      }
      return obj[0];
    },
    /** 获取按钮权限 */
    getButtons(list) {
      const buttons = {};
      list.forEach(item => {
        buttons[item.Title] = item.Buttons ? item.Buttons.split(',') : [];
        // 只有当有子菜单时才存储按钮权限
        // if (item.FatherId === 0 && item.childs && item.childs.length > 0) {
        //   item.childs.forEach(child => {
        //     buttons[child.title] = child.Buttons ? child.Buttons.split(',') : [];
        //   });
        // }
      })
      // console.log('buttons', buttons);
      return buttons
    },
    /**存放权限数据到vuex中，合并为数据 */
    setLimit() {
      //该函数应该放在getNavList回调中
      let path = [];
      this.navList.forEach((ele) => {
        ele.childs.forEach((ele2) => {
          path.push(ele2.path);
        });
      });
      this.$store.commit("setLimitPath", { path: path.join() });
    },

    /**菜单伸缩展开 */
    changeCollapse(bool) {
      if (bool) {
        this.isCollapse = true;
        this.asideStyle = { width: "64px" };
        this.mainStyle = { width: "calc(100% - 64px)" };
      } else {
        this.isCollapse = false;
        this.mainStyle = { width: "calc(100% - 200px)" };
        this.asideStyle = { width: "200px" };
      }
    },

    /**添加tab */
    handleMenu(item) {
      //将组件名称存储到keepAlive
      //再存一份给标签页
      //1、判断缓存组件中是否包含
      let result = this.keepAlive.indexOf(item.path);
      if (result == -1) {
        this.keepAlive.push(item.path);
        this.tabList.push({
          title: item.title,
          path: item.path,
          name: item.path,
        });
      }
      this.activeTab = item.path;
    },
    /**删除tab */
    removeTab(targetName) {
      let tabs = this.tabList;
      if (tabs.length == 1 || targetName === "firstPage") {
        return;
      }
      let activeName = this.activeTab;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.activeTab = activeName;
      this.tabList = tabs.filter((tab) => tab.name !== targetName);
      this.keepAlive = this.keepAlive.filter((item) => item !== targetName);
      this.$router.push(this.activeTab);
    },

    /**点击登出 */
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      } else if (command == "chnagePass") {
        this.passDialog = true;
      }
    },
    /**登出 */
    logout() {
      this.$confirm("确定登出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //清除localStroage，跳转到login
          this.$clearUserInfo();
          this.$router.replace({
            path: "/login",
          });
        })
        .catch(() => {});
    },
    /**重置表单 */
    resetForm() {
      for (const key in this.passFormData) {
        this.passFormData[key] = "";
      }
      this.passDialog = false;
    },
    /**提交表单 */
    submitForm() {
      this.$refs["passForm"].validate((valid) => {
        if (valid) {
          let data = {
            xpwd: this.passFormData.new,
            ypwd: this.passFormData.old,
          };
          this.$request({
            url: "Role/UpdatePwd",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.Code) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.resetForm();
              window.localStorage.removeItem("Token");
              this.$router.replace({
                path: "/login",
              });
            } else {
              this.$message({
                message: res.Msg,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

/******************* aside菜单容器 *******************/
.aside {
  display: inline-block;
  position: relative;
  width: 200px;
  height: 100%;
  background-color: #3a3f51;
  overflow: visible;
  transition: width 0.3s;
}

.close,
.open {
  position: absolute;
  top: 52px;
  font-size: 30px;
  z-index: 9;
}

.close {
  right: -5px;
  color: #fff;
}

.open {
  right: -22px;
}

/* logo */
.aside-logo {
  height: 50px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  border-bottom: 0.5px solid #909399;
  box-sizing: border-box;
  padding: 10px 20px;
  cursor: pointer;
}

.aside-logo-img {
  width: 30px;
  height: 30px;
  vertical-align: -8px;
}

.aside-logo-title {
  font-size: 18px;
  color: #fff;
  margin-left: 10px;
}

/******************* 头部信息 *******************/
.home-header {
  position: relative;
  border-bottom: 0.5px solid #dcdcdc;
}

/* //头部信息容器 */
.header-con {
  text-align: right;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/******************* tabs标签容器 *******************/
.header-con-tabs {
  position: absolute;
  left: 20px;
  top: 0;
  height: 100%;
  width: 880px;
  overflow: hidden;
}

/******************* main菜单容器 *******************/
.main {
  height: 100%;
  display: inline-block;
  width: calc(100% - 200px);
  overflow: hidden;
  transition: width 0.3s;
}

.main-con {
  width: 100%;
  height: calc(100% - 50px);
}

.el-menu {
  border: none;
}

/******************* 过渡动画 *******************/
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter {
  opacity: 0;
  transform: translateX(-30px);
  -webkit-transform: translateX(-30px);
  -ms-transform: translateX(-30px);
  -moz-transform: translateX(-30px);
}

.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-30px);
  -webkit-transform: translateX(-30px);
  -ms-transform: translateX(-30px);
  -moz-transform: translateX(-30px);
}

.userInfo {
  display: inline-block;
  height: 50px;
  font-size: 16px;
  color: #333;
  line-height: 50px;
}

/**菜单搜索 */
.menu-search {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 20px 0 10px;
}

.menu-search-icon {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
}
</style>
